import { Checkbox } from "@rakazo/ui-web";
import { Field, FieldLabel } from "@rakazo/ui-web/components/ui/field";
import type { ReactNode } from "react";
import { useId } from "react";

interface CheckRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  children: ReactNode;
}

/** A checkbox with a label bound by id. */
export function CheckRow({ checked, onChange, disabled, children }: CheckRowProps) {
  const id = useId();
  return (
    <Field orientation="horizontal" className="items-center gap-2">
      <Checkbox id={id} checked={checked} disabled={disabled} onCheckedChange={onChange} />
      <FieldLabel htmlFor={id} className="gap-2 font-normal">
        {children}
      </FieldLabel>
    </Field>
  );
}
